export default "__VITE_ASSET__B_AaBf2O__";